// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Tus credenciales oficiales de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCNMCzH-6xpRDo64Ds4g4rExXlS9o4qq-o",
  authDomain: "luxury-loyalty-oficial.firebaseapp.com",
  projectId: "luxury-loyalty-oficial",
  storageBucket: "luxury-loyalty-oficial.firebasestorage.app",
  messagingSenderId: "867196665550",
  appId: "1:867196665550:web:7be6f098a1fe5b60049a9f"
};

// Inicializar la aplicación de Firebase
const app = initializeApp(firebaseConfig);

// Exportar los servicios para usarlos en el resto de la app
export const db = getFirestore(app); // Base de datos
export const storage = getStorage(app); // Almacenamiento de imágenes
export const auth = getAuth(app); // Autenticación de usuarios